import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateConversationMutationVariables = Types.Exact<{
  participantsIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CreateConversationMutation = { __typename?: 'Mutation', createChatRoom: { __typename?: 'Conversation', id: string, uuid: string, name?: string | null, owner: { __typename?: 'User', id: string, email?: string | null }, members: Array<{ __typename?: 'ChatMember', id: string, lastReadMessageId?: string | null, profile: { __typename?: 'User', id: string, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }>, photo?: { __typename?: 'File', url: string, type: Types.FileType } | null } };


export const CreateConversationDocument = gql`
    mutation CreateConversation($participantsIds: [ID!]!, $name: String) {
  createChatRoom(data: {participants: $participantsIds, name: $name}) {
    id
    uuid
    owner {
      id
      email
    }
    members {
      id
      lastReadMessageId
      profile {
        id
        username
        photoUrl
        firstName
        lastName
      }
    }
    name
    photo {
      url
      type
    }
  }
}
    `;
export type CreateConversationMutationFn = Apollo.MutationFunction<CreateConversationMutation, CreateConversationMutationVariables>;

/**
 * __useCreateConversationMutation__
 *
 * To run a mutation, you first call `useCreateConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationMutation, { data, loading, error }] = useCreateConversationMutation({
 *   variables: {
 *      participantsIds: // value for 'participantsIds'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateConversationMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationMutation, CreateConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationMutation, CreateConversationMutationVariables>(CreateConversationDocument, options);
      }
export type CreateConversationMutationHookResult = ReturnType<typeof useCreateConversationMutation>;
export type CreateConversationMutationResult = Apollo.MutationResult<CreateConversationMutation>;
export type CreateConversationMutationOptions = Apollo.BaseMutationOptions<CreateConversationMutation, CreateConversationMutationVariables>;